module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_FB_red-65900fec669a04c4b022c95c3f47334a.svg";